import React from "react";
import { useNavigate } from "react-router";
import { getDatabase, ref, remove } from "firebase/database";
import { deleteObject, getStorage, ref as storageRef } from "firebase/storage";
import { PenSquare, Plus, Trash2 } from "lucide-react";

import { useNotification } from "../../../contexts/NotificationContext";
import { useCatalog } from "../../../contexts/CatalogContext";
import { Button } from "../../../components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";
import { Item } from "./Item";
import { Title } from "./Title";

export default function Vehicles() {
  const navigate = useNavigate();
  const { vehicles } = useCatalog();
  const { showNotification } = useNotification();

  const handleDeleteVehicle = async (vehicle: string, key: string) => {
    try {
      const db = getDatabase();
      const vehiclesRef = ref(db, `vehicles/${key}`);
      const storage = getStorage();
      const photoRef = storageRef(storage, `vehicles/${key}`);

      await remove(vehiclesRef);
      await deleteObject(photoRef);

      showNotification("success", `Veículo ${vehicle} removido com sucesso.`);
    } catch (error) {
      showNotification("error", `Erro ao remover o veículo ${vehicle}.`);
    }
  };

  return (
    <section className="space-y-3">
      <Title>Veículos</Title>
      <Item className="space-y-4">
        {vehicles.length === 0 ? (
          <p className="text-sm text-white/60">
            Nenhum veículo adicionado ainda.
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nome</TableHead>
                <TableHead>Placa</TableHead>
                <TableHead>Cor</TableHead>
                <TableHead className="text-right">Ações</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {vehicles.map(({ id, data }) => (
                <TableRow key={id}>
                  <TableCell className="font-medium">{data.name}</TableCell>
                  <TableCell>{data.plate}</TableCell>
                  <TableCell>{data.color}</TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-2">
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => navigate(`/admin-management/others/vehicles/edit/${id}`)}
                      >
                        <PenSquare className="h-4 w-4" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleDeleteVehicle(data.name, id)}
                        className="text-destructive"
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
        <Button
          variant="outline"
          className="w-full"
          onClick={() => navigate("/admin-management/others/vehicles/add")}
        >
          <Plus className="mr-2 h-4 w-4" /> Adicionar veículo
        </Button>
      </Item>
    </section>
  );
}
